import type {
  TAudioVideoImportTrackingInput,
  TAudioVideoImportTrackingProperties,
} from '@/types/remote-imports'

function urlHost(url: string): string | null {
  try {
    return new URL(url).hostname
  } catch {
    return null
  }
}

export function audioVideoImportTrackingProperties(
  input: TAudioVideoImportTrackingInput,
): TAudioVideoImportTrackingProperties {
  const properties: TAudioVideoImportTrackingProperties = {
    import_type: input.importType,
    source: input.file ? 'file' : 'url',
  }

  if (input.file) {
    properties.file_name = input.file.name
    properties.file_size_mb = Math.round((input.file.size / 1024 / 1024) * 10) / 10
    properties.file_type = input.file.type
  } else if (input.url) {
    properties.url = input.url
    const host = urlHost(input.url)
    if (host) {
      properties.url_host = host
    }
  }

  if (input.info) {
    properties.duration_seconds = Math.round(input.info.duration)
    properties.content_type = input.info.contentType
    properties.server_import_type = input.info.import_type
  }

  if (input.startedAt) {
    properties.elapsed_seconds = Math.round((Date.now() - input.startedAt.getTime()) / 100) / 10
  }

  if (input.reason) {
    properties.reason = input.reason
  }

  properties.drag_and_drop = input.dragAndDrop

  return properties
}
